import './vendor/bootstrap';
import branchBar from './modules/branch-bar';
import nav from './modules/main-nav.js';
import searchPane from './modules/search-pane.js';
import textSize from './modules/text-size.js';
import modal from './modules/modal';
import videoLiftUp from './modules/video-lift-up.js';
import footnotes from './modules/footnotes.js';
import getUrlParam from './modules/get-url-param.js';
import scrollTo from './modules/scroll-to.js';
import notification from './modules/notification';
import toggle from './modules/toggle';
import CookieDialog from './modules/cookie-dialog';
import governorsGreetingHero from './modules/governors-greeting-hero';
import scrollToggleClass from './modules/scroll-toggle-class';
//Initialize modules' DOM references
import openai from './modules/openai.js';
import sidenav from './modules/sidemenu.js';

//Initialize everything on document ready
function bootstrap() {
  if (window.__SP_BOOTED) return; // run-once guard
  window.__SP_BOOTED = true;

  nav.init();
  sidenav.init();


  // Only load openai component if .openai elements exist on the page
  if (document.querySelector('.openai')) {
    openai();
  }

  searchPane.init();
  textSize.init();
  modal.init();
  videoLiftUp.init();
  footnotes.init();
  notification.init();
  branchBar.init();
  toggle.init();
  governorsGreetingHero.init();
  scrollToggleClass.init();

  const scrollToElementId = getUrlParam('shared');
  if (scrollToElementId) {
    scrollTo('#' + scrollToElementId);
  }

  const cookieDialogElement = document.getElementById('cookie-dialog');
  if (cookieDialogElement) {
    new CookieDialog(cookieDialogElement);
  }
}

// Run immediately if DOM is already ready; else wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}

// Log pageshow for bfcache restores (DOMContentLoaded does not fire on back/forward)
window.addEventListener('pageshow', (e) => {
  if ((window.__SP_DEBUG || localStorage.getItem('sp-debug') === '1') && e.persisted) {
    console.log('[Master]', new Date().toISOString(), 'pageshow (persisted): page restored from bfcache');
  }
});
